import React from "react";
import { DeleteConfirmationModalProps } from "./delete-confirmation-modal.props";
import { ConfirmationModal } from "../confirmation-modal/confirmation-modal.component";

export const DeleteConfirmationModal = (props: DeleteConfirmationModalProps) => (
  <ConfirmationModal
    isOpen={props.isOpen}
    title="Confirm Delete"
    onConfirm={props.onConfirm}
    onCancel={props.onCancel}
  >
    Are you sure you want to delete {props.description}?
  </ConfirmationModal>
);
